/**
 * 加密弹层懒加载壳（21af；ImageConfirmSheetLazy 同构）。
 * 弹层只有点锁徽章才出现，加载期间什么都不渲染——点击与弹层之间差一个
 * 动态 import 的往返（本地块，通常一帧内）。
 */
import { useLazyModule } from './useLazyModule';
import type { EncryptionView } from './EncryptionDialogs';

export function EncryptionDialogsLazy(props: {
  view: EncryptionView;
  mobile: boolean;
  keyInput: string;
  onKeyInput: (v: string) => void;
  onClose: () => void;
  onSubmit: () => void;
  onConfirmClose: () => void;
}) {
  const { mod } = useLazyModule(() => import('./EncryptionDialogs'));
  if (mod === null) return null;
  return <mod.EncryptionDialogs {...props} />;
}
